module.exports = __webpack_public_path__ + "img/Gifcard_pacchetto_D.29d9a7c9.jpg";